/* EDELHOLZ Video-Overlay (18.09.2026) - ein Player fuer alle Video-Sections auf dem Handy.
   Herausgeloest aus der Werkstatt-Wall (sections/edelholz-video-buehne.liquid, 17./18.09.), weil Philipp
   das Verhalten ueberall will: Overlay statt wachsender Kachel, MP4 vom CDN (kein HLS: 2-3 s schwarz),
   Poster sofort, KEINE native Bedienleiste (blieb 3 s stehen), Tipp aufs Video = Pause/Weiter mit Zeichen,
   Schliessen oben rechts, Vollbild nur bei 16:9. Beim Antippen der Kachel (pointerdown) kann die Section das
   Video schon vorwaermen: EHVideoOverlay.warm(src, poster).
   API: EHVideoOverlay.oeffne({ src, poster, breit, label, opener, beiEnde }) / .schliesse() / .istMobil() */
(function () {
  if (window.EHVideoOverlay) return;
  var CSS = ''
    + '.eh-vo{position:fixed;inset:0;z-index:9999;background:rgba(20,22,24,.92);display:flex;align-items:center;justify-content:center;padding:16px}'
    + '.eh-vo[hidden]{display:none}'
    + '.eh-vo__frame{position:relative;background:#000;border-radius:var(--eh-radius-card,6px);overflow:hidden}'
    + '.eh-vo--hoch .eh-vo__frame{aspect-ratio:9/16;width:min(80vw,calc(80vh * 9 / 16),460px)}'
    + '.eh-vo--breit .eh-vo__frame{aspect-ratio:16/9;width:100%;max-width:1100px}'
    + '.eh-vo__frame video{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#000;display:block}'
    + '.eh-vo__tap{position:absolute;inset:0;z-index:1;background:transparent;border:0;padding:0;margin:0;cursor:pointer;-webkit-tap-highlight-color:transparent}'
    + '.eh-vo__pause{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:64px;height:64px;border-radius:50%;background:rgba(20,22,24,.55);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:2}'
    + '.eh-vo__pause[hidden]{display:none}'
    + '.eh-vo__pause svg{width:26px;height:26px;fill:#fff;margin-left:3px}'
    + '.eh-vo__close{position:absolute;top:8px;right:8px;width:44px;height:44px;border-radius:999px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.35);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;z-index:3}'
    + '.eh-vo__close svg{width:20px;height:20px;stroke:currentColor;stroke-width:1.6;fill:none}'
    + '.eh-vo__voll{position:absolute;right:16px;bottom:8px;display:inline-flex;align-items:center;gap:8px;min-height:44px;background:none;border:0;padding:0;cursor:pointer;font-family:var(--eh-ff-text,Montserrat,sans-serif);font-size:14px;font-weight:500;color:rgba(255,255,255,.85);z-index:3}'
    + '.eh-vo__voll[hidden]{display:none}'
    + '.eh-vo__voll svg{width:20px;height:20px;stroke:currentColor;stroke-width:1.6;fill:none}'
    + '@media (max-width:749px){.eh-vo--breit{padding-inline:0}.eh-vo--breit .eh-vo__frame{border-radius:0}}';

  var ov = null, frame, closeBtn, vollBtn, video = null, letzterFokus = null, bodyOverflow = '', beiEnde = null, warm = { src: '', v: null };

  function bauen() {
    if (ov) return;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    ov = document.createElement('div'); ov.className = 'eh-vo'; ov.hidden = true; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Video');
    ov.innerHTML = '<button type="button" class="eh-vo__close" data-eh-vo-close aria-label="Schließen"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
      + '<div class="eh-vo__frame" data-eh-vo-frame></div>'
      + '<button type="button" class="eh-vo__voll" data-eh-vo-voll hidden><svg viewBox="0 0 24 24"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>Vollbild</button>';
    document.body.appendChild(ov);
    frame = ov.querySelector('[data-eh-vo-frame]'); closeBtn = ov.querySelector('[data-eh-vo-close]'); vollBtn = ov.querySelector('[data-eh-vo-voll]');
    closeBtn.addEventListener('click', schliesse);
    wischenZumSchliessen(ov, frame, schliesse);
    ov.addEventListener('click', function (e) { if (e.target === ov) schliesse(); });
    vollBtn.addEventListener('click', function () {
      if (!video) return;
      if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); else if (video.requestFullscreen) video.requestFullscreen();
    });
  }
  function aufTaste(e) { if (e.key === 'Escape') schliesse(); }

  /* Wischen nach unten schliesst (Philipp 18.09., wie Instagram). Das X bleibt. Nur senkrechte Wischer ab 90 px, der Rahmen
     folgt dem Finger und faehrt zurueck, wenn es nicht reicht. */
  function wischenZumSchliessen(ov, frame, schliesse) {
    var y0 = null, x0 = null, dy = 0, aktiv = false;
    ov.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0; aktiv = false; frame.style.transition = 'none'; }, { passive: true });
    ov.addEventListener('touchmove', function (e) {
      if (y0 === null || e.touches.length !== 1) return;
      var ny = e.touches[0].clientY - y0, nx = e.touches[0].clientX - x0;
      if (!aktiv) { if (Math.abs(ny) < 12 || Math.abs(nx) > Math.abs(ny)) return; aktiv = true; }
      dy = Math.max(0, ny);
      frame.style.transform = 'translateY(' + dy + 'px)';
      ov.style.opacity = String(Math.max(0.4, 1 - dy / 600));
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    function ende() {
      if (y0 === null) return;
      var zu = aktiv && dy > 90;
      y0 = null; frame.style.transition = 'transform .25s ease'; ov.style.transition = 'opacity .25s ease';
      if (zu) { frame.style.transform = 'translateY(120vh)'; ov.style.opacity = '0'; setTimeout(function () { schliesse(); frame.style.transition = ''; frame.style.transform = ''; ov.style.transition = ''; ov.style.opacity = ''; }, 220); }
      else { frame.style.transform = ''; ov.style.opacity = ''; setTimeout(function () { frame.style.transition = ''; ov.style.transition = ''; }, 260); }
    }
    ov.addEventListener('touchend', ende, { passive: true });
    ov.addEventListener('touchcancel', ende, { passive: true });
  }

  function warmes(src, poster, label) {
    if (warm.v && warm.src === src) return warm.v;
    var v = document.createElement('video');
    v.src = src; v.setAttribute('playsinline', ''); v.preload = 'auto'; v.controls = false;
    if (label) v.setAttribute('aria-label', label);
    if (poster) v.poster = poster;
    try { v.load(); } catch (e) { }
    warm = { src: src, v: v };
    return v;
  }

  function oeffne(o) {
    if (!o || !o.src) return;
    bauen();
    if (video) schliesse();
    frame.innerHTML = '';
    var v = warmes(o.src, o.poster, o.label); warm = { src: '', v: null };
    frame.appendChild(v);
    var tap = document.createElement('button'); tap.type = 'button'; tap.className = 'eh-vo__tap'; tap.setAttribute('aria-label', 'Pause oder weiter');
    var z = document.createElement('span'); z.className = 'eh-vo__pause'; z.hidden = true; z.setAttribute('aria-hidden', 'true');
    z.innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
    frame.appendChild(tap); frame.appendChild(z);
    /* Eigene Tipp-Flaeche ueber dem Video: iOS liefert auf einem laufenden <video> ohne Bedienleiste nicht zuverlaessig click. */
    tap.addEventListener('click', function () { if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () { }); } else v.pause(); });
    v.addEventListener('pause', function () { if (!v.ended) z.hidden = false; });
    v.addEventListener('play', function () { z.hidden = true; });
    v.addEventListener('ended', function () { if (video !== v) return; var f = beiEnde; schliesse(); if (typeof f === 'function') f(); });
    video = v; beiEnde = o.beiEnde || null;
    ov.classList.toggle('eh-vo--breit', !!o.breit); ov.classList.toggle('eh-vo--hoch', !o.breit);
    vollBtn.hidden = !o.breit;
    letzterFokus = o.opener || document.activeElement;
    bodyOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    ov.hidden = false;
    document.addEventListener('keydown', aufTaste);
    closeBtn.focus({ preventScroll: true });
    v.muted = false;
    var p = v.play(); if (p && p.catch) p.catch(function () { z.hidden = false; });
  }

  function schliesse() {
    if (!ov || ov.hidden) return;
    if (video) { try { video.pause(); } catch (e) { } video.removeAttribute('src'); try { video.load(); } catch (e) { } video = null; }
    frame.innerHTML = '';
    ov.classList.remove('eh-vo--breit', 'eh-vo--hoch');
    ov.hidden = true;
    document.body.style.overflow = bodyOverflow;
    document.removeEventListener('keydown', aufTaste);
    if (letzterFokus && letzterFokus.focus) { try { letzterFokus.focus({ preventScroll: true }); } catch (e) { } }
    letzterFokus = null; beiEnde = null;
  }

  window.addEventListener('pagehide', function () { if (video) { try { video.pause(); } catch (e) { } } });
  window.EHVideoOverlay = { oeffne: oeffne, schliesse: schliesse, warm: warmes, istMobil: function () { return window.matchMedia('(max-width: 749px)').matches; } };
})();
